const questions = [
    {
        ques: 'What is the third angle for the triangle where angle1 = 45° and angle2 = 45°?',
        options: ['45°', '90°', '60°'],
        ans: '90°'
    },
    {
        ques: 'What is the third angle for the triangle where angle1 = 45° and angle2 = 45°?',
        options: ['obtuse', 'acute', 'right angled'],
        ans: 'right angled'
    },
    {
        ques: 'A triangle can have',
        options: ['one right angle', 'two right angle'],
        ans: 'one right angle'
    },
    {
        ques: 'The perimeter of scalene triangle with sides a, b, c is',
        options: ['a+b+c', '2a', 'None of these'],
        ans: 'a+b+c'
    },
    {
        ques: 'Which of the following can form a right angled triangle?',
        options: ['14,15,26', '12,16,20'],
        ans: '12,16,20'
    },
]

export default questions